const TwitterIcon = ({ color }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g>
        <path d="M8.36 7.742l10.835 14.48h2.453L10.813 7.743zm0 0"></path>
        <path d="M.164.164v29.637h29.637V.164zm18.453 23.219l-4.933-6.598-6.106 6.598H6.012l6.972-7.535-6.93-9.262h5.34l4.543 6.074 5.622-6.074h1.57l-6.492 7.012 7.32 9.785zm0 0"></path>
      </g>
    </svg>
  )
}

export default TwitterIcon
